import { GfsOfferCoverLetterPage } from "@/services/backend/gfs/offer/components/offer-cover-letter-page";

export default function GfsOfferCoverLetterRoute() {
  return <GfsOfferCoverLetterPage />;
}
